import { useGetMasteryQuery } from "../masterySlice";

const useMasteryPage = () => {
  const mastery = useGetMasteryQuery();
  return { mastery: mastery?.data || [], masteryLoading: mastery?.isLoading };
};

export default useMasteryPage;
